import React from 'react';
import './Img.css';
const Img = (props: any) => {
  let allProps = {
    ...props,
  };

  return (
    <>
      <img {...allProps} loading='lazy' alt={props.alt} />
    </>
  );
};

export default Img;
